var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeatherSnow = function SvgWeatherSnow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M7.872 19v.75h3.249v-2.602h2.629v-3.296h-2.63V11.25H7.873v2.602H5.25v3.296h2.622z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "m16.79 24.497.53.53.53-.53 1.185-1.185.53-.53-.53-.53-1.232-1.233 1.251-1.252.53-.53-.53-.53-1.217-1.218-.53-.53-.53.53-1.252 1.252-1.233-1.233-.53-.53-.53.53-1.185 1.185-.53.53.53.53 1.233 1.233-1.247 1.247-.53.53.53.53 1.217 1.218.53.53.53-.53 1.247-1.247z"
  })));
};
export default SvgWeatherSnow;